import { Button, Checkbox } from 'antd';
import { NavLink, Route, Switch, useHistory } from 'react-router-dom';
import React, { useState, useEffect, useCallback } from 'react';
import { dataCustomerIssue, dataIssue } from '../../../../Data/dataIssue';
import { PaginationMemo } from './../../../Pagination/index';
import DotComponent from '../../../ComponentReuse/Dot';
import PopoverComponent from '../../../ComponentReuse/PopoverComponent';
const TableCustomerIssue = () => {
	const [postsPerPage, setPostsPerPage] = useState(20);
	const [totalEntries, setTotalEntries] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);

	useEffect(() => {
		setTotalEntries(dataCustomerIssue.length);
	}, [dataCustomerIssue]);
	const handleBack = useCallback(() => {
		if (currentPage > 1) {
			setCurrentPage(currentPage - 1);
		}
	}, [currentPage]);
	const handleNext = () => {
		if (currentPage < Math.ceil(totalEntries / postsPerPage)) {
			setCurrentPage(currentPage + 1);
		}
		console.log('abc');
	};
	const handleChoosePage = useCallback((page) => {
		setCurrentPage(page);
	}, []);
	const handleSetPostsPerPage = useCallback((entries) => {
		setPostsPerPage(entries);
		setCurrentPage(1);
	}, []);
	const backgroundTheme = (text) => {
		let background = '';
		if (text.toLowerCase() === 'new') {
			background = '#AEE9D1';
		} else if (text.toLowerCase() === 'wait on 3rd party') {
			background = '#8E59FF';
		} else if (text.toLowerCase() === 'wait on customer') {
			background = '#2F80ED';
		} else if (text.toLowerCase() === 'pending') {
			background = '#F2C94C';
		} else if (text.toLowerCase() === 'resolved') {
			background = '#836100';
		} else if (text.toLowerCase() === 'closed') {
			background = '#6F767E';
		} else background = '#27AE60';

		return background;
	};
	const history = useHistory();
	const handleClickToInforIssues = () => {
		history.push('/issues/issue-info');
	};
	return (
		<>
			<div className="mobile:overflow-auto">
				<table className="xl:table-fixed mobile:table-auto w-full rounded-5px hide-order mobile:overflow-auto">
					<thead>
						<tr className="bg-gray border-y">
							<td className="px-2 py-2.5 none-border">
								<Checkbox />
								<span className="mx-2">Code</span>
							</td>
							<td className="px-2 py-2.5 border-y none-border truncate">
								Order name
							</td>
							<td className="px-2 py-2.5 none-border truncate">
								Customer Message
							</td>
							<td className="px-2 py-2.5 none-border">Kind</td>
							<td className="px-2 py-2.5 none-border truncate">Created at</td>
							<td className="px-2 py-2.5 none-border truncate">Agent Note</td>
							<td className="px-2 py-2.5 none-border truncate">
								Time Remaining
							</td>
							<td className="px-2 py-2.5 none-border truncate">CS State</td>
							<td className="px-2 py-2.5 none-border ">Agent</td>
							<td className="px-2 py-2.5 none-border truncate">Kind level 1</td>
							<td className="px-2 py-2.5 none-border truncate">Kind level 2</td>
							<td className="px-2 py-2.5 none-border truncate">Kind level 3</td>
						</tr>
					</thead>
					<tbody>
						{dataCustomerIssue.map((item, index) => {
							if (
								index >= (currentPage - 1) * postsPerPage &&
								index < currentPage * postsPerPage
							) {
								return (
									<tr
										key={index}
										className={
											index % 2 !== 0
												? 'bg-gray border-tr'
												: 'bg-white border-tr'
										}
									>
										<td className="px-2 py-2.5 none-border truncate  cursor-pointer">
											<Checkbox />
											<span className="mx-2" onClick={handleClickToInforIssues}>
												{item.code}
											</span>
										</td>
										<td className="px-2 py-2.5 none-border truncate ">
											{item.orderName}
										</td>
										<td className="px-2 py-2.5 none-border truncate cursor-pointer">
											<PopoverComponent text={item.customerMessage} />
										</td>
										<td className="px-2 py-2.5 none-border truncate cursor-pointer">
											<PopoverComponent text={item.kind} />
										</td>
										<td className="px-2 py-2.5 none-border truncate ">
											{item.creatAt}
										</td>
										<td className="px-2 py-2.5 none-border truncate cursor-pointer">
											<PopoverComponent text={item.agentNote} />
										</td>
										<td className="py-2.5 my-auto none-border truncate  flex flex-nowrap">
											<DotComponent
												bgColor={item.statusTime ? 'bg-red1' : 'bg-gray2'}
											/>
											<span className="">{item.timeRemaining}</span>
										</td>
										<td className="px-2 py-2.5 none-border truncate cursor-pointer">
											<PopoverComponent
												text={item.csState}
												item={item.csState}
												bg={backgroundTheme(item.csState)}
												styled={`px-1 rounded-5px py-0.5 text-10px ${
													item.csState == 'New' ? 'text-black' : 'text-white'
												}`}
											/>
										</td>
										<td className="px-2 py-2.5 none-border truncate ">
											{item.agent}
										</td>
										<td className="px-2 py-2.5 none-border truncate ">
											{item.kindLevel1}
										</td>
										<td className="px-2 py-2.5 none-border truncate ">
											{item.kindLevel2}
										</td>
										<td className="px-2 py-2.5 none-border truncate ">
											{item.kindLevel3}
										</td>
									</tr>
								);
							}
						})}
					</tbody>
				</table>
			</div>
			<div className="p-5">
				<PaginationMemo
					handleBack={handleBack}
					handleNext={handleNext}
					handleChoosePage={handleChoosePage}
					handleSetPostsPerPage={handleSetPostsPerPage}
					postsPerPage={postsPerPage}
					totalPosts={totalEntries}
					currentPage={currentPage}
				/>
			</div>
		</>
	);
};
export default TableCustomerIssue;
